import { useTranslation } from 'react-i18next';
import { Form, Modal, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useAddCargoToTripTask } from 'api/trip-task/use-add-cargo-to-trip';
import { useGetTripTasks } from 'api/trip-task/use-get-trip-tasks';
import { NON_ATTACHABLE_TASK_TYPES } from './constants';
import type { ITripAddCargoModalProps, ITripAddCargoFormFields } from './types';

export const TripAddCargoModal = (props: ITripAddCargoModalProps) => {
  const { open, tripId, cargoTripIds, onCancel, onSuccess } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const { data: tripTasks, isLoading } = useGetTripTasks({ tripId });
  const { mutateAsync: addCargoToTripTask } = useAddCargoToTripTask(tripId);

  const handleOk = debounce(() => form.submit(), 200);

  const onFinish = async (values: ITripAddCargoFormFields) => {
    await addCargoToTripTask({ tripTaskId: values.tripTaskId, cargoTripIds });
    form.resetFields();
    onSuccess();
    onCancel();
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const options = tripTasks
    ?.filter((task) => !NON_ATTACHABLE_TASK_TYPES.includes(task.type))
    .map((task) => ({
      value: task.id,
      label: `${task.type} - ${task.status}`,
    }));

  return (
    <Modal open={open} title={t('trip:add_cargo_to_trip')} width={500} onCancel={handleCancel} onOk={handleOk}>
      <Form form={form} layout='vertical' style={{ marginTop: 16 }} onFinish={onFinish}>
        <Form.Item
          label={t('trip:trip_task')}
          name='tripTaskId'
          rules={[{ required: true, message: t('trip:select_trip_task') }]}>
          <Select placeholder={t('trip:select_trip_task')} loading={isLoading} options={options} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
